import { ISourcingToolSearchFilter } from "react-migration/domains/search/typings/SourcingToolSpecificFilterTypes";
import { SearchType } from "react-migration/domains/search/constants/searchTypes";

export const LeaseEndDateFilter: ISourcingToolSearchFilter = {
  id: "lease-end-date",
  type: "date-range",
  field: "sidebar.react.search_sidebar.lease_end_date",
  range: [null, null],
  granularity: "month",
  updateFilterDialogIsVisible: false,
  searchTypes: [SearchType.SOURCING_TOOL_UK],
};
